module.exports = __webpack_public_path__ + "img/jttuijin.3328e194.gif";